var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.38125 13.3486C3.43837 12.9708 3.76314 12.6914 4.1453 12.6914H8.73822C9.11178 12.6914 9.43186 12.9586 9.49854 13.3262L10.6349 19.5901C10.7209 20.0644 10.3565 20.5008 9.87453 20.5008H3.19837C2.72559 20.5008 2.36366 20.08 2.43432 19.6126L3.38125 13.3486Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.286 13.3486C14.3432 12.9708 14.6679 12.6914 15.0501 12.6914H19.643C20.0166 12.6914 20.3366 12.9586 20.4033 13.3262L21.5396 19.5901C21.6257 20.0644 21.2613 20.5008 20.7793 20.5008H14.1032C13.6304 20.5008 13.2684 20.08 13.3391 19.6126L14.286 13.3486Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8312 3.85644C8.88832 3.47858 9.21309 3.19922 9.59525 3.19922H14.1882C14.5617 3.19922 14.8818 3.46645 14.9485 3.83402L16.0848 10.0979C16.1708 10.5722 15.8065 11.0086 15.3245 11.0086H8.64832C8.17554 11.0086 7.81361 10.5878 7.88428 10.1204L8.8312 3.85644Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldIcon);
export default __webpack_public_path__ + "static/media/Gold Icon.87cdda05d4db9d8b4da9dd6c9652ab71.svg";
export { ForwardRef as ReactComponent };